import { definePolicies } from '@libs/shared/frontend/helpers/define-policies.helper';
import { constant as rConstant } from 'remeda';

import { OrganizationAccessControlModuleEnum, type components } from '@/libs/openapi/schema';
import { hasModule } from '@/utils/permissions.util';

interface PolicyContext {
  user: components['schemas']['MeResponseDto'];
  organization: components['schemas']['OrganizationResponseDto'] | undefined;
}

export const reportPolicies = definePolicies((globalCtx: PolicyContext) => ({
  view: rConstant(hasModule(globalCtx.organization, OrganizationAccessControlModuleEnum.REPORTING)),
}));
